<template>
	<Dropdown v-model="inputValue" :options="enumService.getCategoryEnum()" optionLabel="Name" optionValue="Id" :placeholder="placeholder" @change="onChange($event)" />
</template>

<script>
import EnumService from "@/service/EnumService";

export default {
	props: ["value", "placeholder"],
	data: function() {
		return {};
	},
	enumService: null,
	created() {
		this.enumService = new EnumService();
	},
	methods: {
		onChange(event) {
			this.$emit("change", event);
		}
	},
	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	}
};
</script>